export class WsBaseAddress {
    encodedId: string;
    firstName?: string;
    lastName?: string;
    companyName?: string;
    zipCode: string;
    city: string;
    countryCodeIso: string;
    active: boolean;

    constructor(
        encodedId: string,
        firstName: string | undefined,
        lastName: string | undefined,
        companyName: string | undefined,
        zipCode: string,
        city: string,
        countryCodeIso: string,
        active: boolean
    ) {
        this.encodedId = encodedId;
        this.firstName = firstName;
        this.lastName = lastName;
        this.companyName = companyName;
        this.zipCode = zipCode;
        this.city = city;
        this.countryCodeIso = countryCodeIso;
        this.active = active;
    }

    isGermanAddress(): boolean {
        return this.countryCodeIso.toUpperCase() === 'DE';
    }
}
